import RECOMMENDED_PRODUCTS_CONFIG from "./RecommendedProducts";

const CAROUSEL_DISPLAY_CONFIG = {
  RecommendedProducts: RECOMMENDED_PRODUCTS_CONFIG,
};

export default CAROUSEL_DISPLAY_CONFIG;
